import { render, staticRenderFns } from "./create_memorandum.vue?vue&type=template&id=6de599e0&scoped=true&"
import script from "./create_memorandum.vue?vue&type=script&lang=js&"
export * from "./create_memorandum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de599e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de599e0')) {
      api.createRecord('6de599e0', component.options)
    } else {
      api.reload('6de599e0', component.options)
    }
    module.hot.accept("./create_memorandum.vue?vue&type=template&id=6de599e0&scoped=true&", function () {
      api.rerender('6de599e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/create_memorandum.vue"
export default component.exports